// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ProductsNotExist_wrapper__3bqHj","asset":"ProductsNotExist_asset__EbZvJ","notice":"ProductsNotExist_notice__2axc4","advise":"ProductsNotExist_advise__37JpB"};